import { useTranslation } from 'react-i18next'

import { cn } from '#/shared/lib/utils'
import { Button } from '#/shared/ui/button'
import { ChevronRightIcon } from '#/shared/ui/icons'

interface RequestsButtonProps {
  count?: number
  onClick?: () => void
}

export function RequestsButton({ count = 0, onClick }: RequestsButtonProps) {
  const { t } = useTranslation()
  return (
    <Button
      type="button"
      variant="outline"
      size="xs"
      pressEffect
      onClick={onClick}
      className={cn(
        'group w-full justify-between px-2.5 text-gray-900 md:w-auto md:justify-center',
      )}
    >
      <span className="flex items-center gap-1.5">
        {count > 0 && (
          <span className="flex size-4.5 items-center justify-center rounded-full bg-orange-500 text-xs text-white">
            {count}
          </span>
        )}
        {t('detailToolbar.requests')}
      </span>
      <ChevronRightIcon className="size-2.5 transition-transform duration-150 ease-out group-hover:translate-x-0.5" />
    </Button>
  )
}
